import _ from 'lodash';
import { Observable } from 'rxjs';
import { from } from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import { mergeMap, concatMap, switchMap, map, delay, takeUntil, catchError, finalize, endWith } from 'rxjs/operators';
import {
  FETCH_INTERCOM_LOCKS_BY_TAGS,
  CANCEL_FETCH_INTERCOM_LOCKS_BY_TAGS,
  FETCH_EXTENSION_USERS_BY_TAGS,
  CANCEL_FETCH_EXTENSION_USERS_BY_TAGS,
} from '../redux/actions/actionTypes/intercom';

import * as RestService from '../_config/rest';
import {
  setIntercomLocksFilteredByTagsEpic,
  setExtensionUsersFilteredByTagsEpic,
} from '../redux/actions/intercom.actions';
import { rxFetch } from './utils';
import moment from 'moment';

export const fetchIntercomLocksByTagsEpic = (action$, store) =>
  action$.ofType(FETCH_INTERCOM_LOCKS_BY_TAGS)
    .debounceTime(500)
    .switchMap((action) => {
      const { lockTagMatchingMode, page, append, index } = action;
      let tags = action.tags;
      if (!_.isArray(tags)) {
        tags = [tags];
      }

      if (tags && tags.length) {
        const params = {
          tagIds: _.map(tags, tag => tag.id || tag),
          page,
          lockTagMatchingMode,
        };

        return rxFetch(RestService.fetchLocksByTags(params))
          .map((response) => {
            if (response.data && response.data.content) {
              const locks = response.data.content;
              const pagination = _.omit(response.data, 'content');
              return setIntercomLocksFilteredByTagsEpic(locks, index, pagination, append);
            }
            return setIntercomLocksFilteredByTagsEpic([], index);
          })
          .takeUntil(action$.ofType(CANCEL_FETCH_INTERCOM_LOCKS_BY_TAGS))
          .catch(() => Observable.empty());
      }
      return Observable.of(setIntercomLocksFilteredByTagsEpic([], index));
    });


export const fetchExtensionUsersByTagsEpic = (action$, store) =>
  action$.ofType(FETCH_EXTENSION_USERS_BY_TAGS)
    .debounceTime(500)
    .switchMap((action) => {
      const { userTagMatchingMode, page, append, index } = action;
      let tags = action.tags;
      if (!_.isArray(tags)) {
        tags = [tags];
      }

      if (tags && tags.length) {
        const params = {
          tagIds: _.map(tags, tag => tag.id || tag),
          page,
          userTagMatchingMode,
        };

        return rxFetch(RestService.fetchUsersByTags(params))
          .map((response) => {
            if (response.data && response.data.content) {
              const users = response.data.content;
              const pagination = _.omit(response.data, 'content');
              return setExtensionUsersFilteredByTagsEpic(users, index, pagination, append);
            }
            return setExtensionUsersFilteredByTagsEpic([], index);
          })
          .takeUntil(action$.ofType(CANCEL_FETCH_EXTENSION_USERS_BY_TAGS))
          .catch(() => Observable.empty());
      }
      return Observable.of(setExtensionUsersFilteredByTagsEpic([], index));
    });